import { createAction } from 'redux-actions';
import { actionKey } from './constants';

export const appMounted = createAction(`${actionKey}/MOUNTED`, () => ({}));
export const appUnmounted = createAction(`${actionKey}/UNMOUNTED`, () => ({}));

export const appVisibilityChange = createAction(`${actionKey}/VISIBILITY`, (hidden: boolean) => ({
  hidden,
}));
